import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme)=>({
        card: {
            '&:hover': {
                backgroundColor: theme.tokens.colors.bg.greyscale.tertirary
            }
        }
    }));
export { useStyles };
